import React from 'react'
import StarPlatinum from 'app/components/icons/StarPlatinum'
import { aiBackgroundGradient } from 'app/configs/aiBackgroundConfigs'
const TourHeaderComponent = (props) => {
  const { text } = props
  return (
    <div
      style={aiBackgroundGradient}
      className="flex flex-row p-16 text-white text-lg font-bold rounded-lg items-center text-left"
    >
      <StarPlatinum className="px-4" width={40} height={40}></StarPlatinum>
      <span className="px-16">{text}</span>
    </div>
  )
}

export default React.memo(TourHeaderComponent)
